import clinicAPI from "../services/clinicApi";
import {
  listPendingMutations,
  removeMutation,
} from "./journalOfflineStore";

export async function flushJournalSyncQueue(tenantKey) {
  if (!tenantKey || !navigator.onLine) {
    return { synced: 0, failed: 0, remaining: 0 };
  }

  const pending = await listPendingMutations(tenantKey);
  if (!pending.length) {
    return { synced: 0, failed: 0, remaining: 0 };
  }

  let synced = 0;
  let failed = 0;

  for (const row of pending) {
    try {
      await clinicAPI.markSessionAttendance(row.sessionId, {
        patient_id: row.patientId,
        ...row.payload,
        absence_reason: row.payload?.clear
          ? undefined
          : row.payload?.absence_reason,
      });
      await removeMutation(row.id);
      synced += 1;
    } catch {
      failed += 1;
    }
  }

  const remaining = (await listPendingMutations(tenantKey)).length;
  return { synced, failed, remaining };
}
